import { render, staticRenderFns } from "./button-action-ribbon.vue?vue&type=template&id=66a05862&scoped=true&"
import script from "./button-action-ribbon.vue?vue&type=script&lang=js&"
export * from "./button-action-ribbon.vue?vue&type=script&lang=js&"
import style0 from "./button-action-ribbon.vue?vue&type=style&index=0&id=66a05862&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a05862",
  null
  
)

export default component.exports